module.exports = __webpack_public_path__ + "static/lineart-texture-light-f11d1aa3fd1034fd7970c3f515ff72f6.svg";